module.exports = " <main class=app> <top :title=title></top> <view></view> <grid :columns.sync=columns></grid> <symbols></symbols> </main> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 737
// module chunks = 2